import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function searchFormRoutes($stateProvider: StateProvider) {
    let searchFormModule: { default: any; };
    $stateProvider
        .state({
            name: 'search-form',
            url: '/search-form',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => searchFormModule.default,
            },
            lazyLoad: async () => {
                searchFormModule = await import(/* webpackChunkName: "searchFormPage" */ './KpSearchFormPage.svelte');
                return null;
            }
        });
}